import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createStoreSelectors } from './createStoreSelectors';

type DownloadHistoryState = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  toggleOpen: () => void;
};

const downloadHistoryStoreBase = create(
  devtools<DownloadHistoryState>(
    (set) => ({
      isOpen: false,
      setOpen: (isOpen: boolean) => set({ isOpen }, false, 'setOpen'),
      toggleOpen: () =>
        set((state: DownloadHistoryState) => ({ isOpen: !state.isOpen }), false, 'toggleOpen'),
    }),
    {
      name: 'download-history',
    },
  ),
);

export const downloadHistoryStore = createStoreSelectors(downloadHistoryStoreBase);
